import React from 'react'
import cn from 'classnames'

const FilterButton = ({
  active,
  onSelect,
  data,
  mapper = strs => strs.join(', '),
  minGroup = 2,
  maxChars = 28,
  label,
  groupLabel,
  className,
}) => {
  const showCount = !label && data && (data.length > minGroup || mapper(data).length > maxChars)
  return (
    <button
      type="button"
      className={cn('search-button', className, active && 'search-button-active', showCount && 'showing-count')}
      onClick={() => onSelect()}>
      {label ? (
        label
      ) : (
        <>
          {showCount && <span className="search-button-count">{data.length}</span>}
          {showCount ? groupLabel : mapper(data)}
        </>
      )}
    </button>
  )
}

export default FilterButton
